

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class FlatSelectorTextInput extends Vue {
  // PROPS
  @Prop() private placeholder!: string;
  @Prop() private valueSelected!: string;
  @Prop() private colorSelected!: string;
  @Prop() private readOnly!: boolean;
  @Prop({ default: false }) private multipleValues!: boolean;
  @Prop({ default: false }) private squad!: boolean;

  // DATA
  private valueSelectedData: string = '';
  private isFocused: boolean = false;

  // LIFECYCLE HOOKS
  private created() {
    this.valueSelectedData = this.valueSelected;
  }

  private updated() {
    if (!this.isFocused && this.valueSelected === '') {
      this.valueSelectedData = '';
    } else if (
      !this.isFocused &&
      this.valueSelected !== this.valueSelectedData
    ) {
      this.valueSelectedData = this.valueSelected;
    }
  }

  // Watchers
  @Watch('valueSelected')
  private onValueSelectedChanged(newVal: string, oldVal: string) {
    this.valueSelectedData = newVal;
  }

  // Computed methods
  get colorSelectedClass() {
    return this.colorSelected;
  }

  get hasFocus() {
    const focus = this.isFocused && !this.readOnly;
    return focus;
  }

  // METHODS
  private checkFilteringNeeded() {
    this.$emit('filterOptions', this.valueSelectedData);
  }

  private handleFocus() {
    this.isFocused = true;
    this.$emit('focus');
  }

  private handleBlur() {
    if (!this.multipleValues) {
      this.$emit('blur');
    } 
    this.valueSelectedData=""
    this.isFocused = false;
  }
}
